/**
 * useDynamicManifest — swap the document <link rel="manifest"> based on
 * the current route so each standalone Tool installs as its own PWA.
 *
 * Per FINAL_PLATFORM_STRUCTURE.md §36-46:
 *   "PWA installs under tool's own name (not 'RemodDash')."
 *
 * Falls back to the platform manifest on every other route.
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const TOOL_MANIFESTS = {
  '/remodforms': '/manifests/remodforms.json',
  '/remodpay': '/manifests/remodpay.json',
  '/remodinventory': '/manifests/remodinventory.json',
};

const PLATFORM_MANIFEST = '/manifest.json';

export default function useDynamicManifest() {
  const location = useLocation();

  useEffect(() => {
    // Match the most specific tool route first (longest path wins).
    const path = location.pathname || '/';
    let chosen = PLATFORM_MANIFEST;
    for (const route of Object.keys(TOOL_MANIFESTS)) {
      if (path === route || path.startsWith(route + '/')) {
        chosen = TOOL_MANIFESTS[route];
        break;
      }
    }
    let link = document.querySelector('link[rel="manifest"]');
    if (!link) {
      link = document.createElement('link');
      link.rel = 'manifest';
      document.head.appendChild(link);
    }
    if (link.getAttribute('href') !== chosen) {
      link.setAttribute('href', chosen);
    }
  }, [location.pathname]);
}
